module.exports = __webpack_public_path__ + "img/guide_01_01.686150ee.png";